// extracted by mini-css-extract-plugin
export var active = "_fg-2";
export var recordingDot = "_fg-1";
export var recordingIndicator = "_fg-0";